import { render, staticRenderFns } from "./OrganizationServices.vue?vue&type=template&id=0b1f7422&scoped=true&"
import script from "./OrganizationServices.vue?vue&type=script&lang=js&"
export * from "./OrganizationServices.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationServices.vue?vue&type=style&index=0&id=0b1f7422&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f7422",
  null
  
)

export default component.exports